import React from 'react';
import Skeleton from 'react-loading-skeleton';

const StatCardLoader = () => (
  <div className="bg-gray-50 rounded-lg p-3">
    <Skeleton width="80%" height={12} className="mb-2" />
    <Skeleton width="60%" height={20} />
  </div>
);

export default StatCardLoader;
